import { NavLink, useLocation, useParams } from "react-router-dom";
import { NewPlanModal } from "../_modals/NewPlanModal";
import { useModal } from "../_providers/ModalProvider";
import { usePlan } from "../_providers/PlanProvider";
import routing from "../routing";
import { useEffect, useState } from "react";
import { useLang } from "../_providers/LangProvider";
import "./SideBar.css";
import { relative } from "path";
import { useAuth } from "../_providers/AuthProvider";

const SideBar = () => {
    const {plans, selectPlan, selectedPlan} = usePlan();
    const { lang } = useParams();
    const {translate} = useLang();
    const {user} = useAuth();
    const loc = useLocation();
    
    const [openPlans, setOpenPlans] = useState(false);

    const {setModal} = useModal();


    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            const modalElement = document.getElementById('modal');
            if (modalElement && !modalElement.contains(event.target as Node)) {
              setOpenPlans(false);
            }
          };
      
          document.addEventListener('mousedown', handleClickOutside);
    }, [])

    const handleSelect = (plan_uid: string) => {
        if (plan_uid === "new") {
            setModal("New plan", <NewPlanModal/>)
            return;
        }
        const selectedPlan = plans.find((plan) => plan.uid === plan_uid);
        if (selectedPlan) {
            console.log("Handle select plan: ", selectedPlan);
            selectPlan(selectedPlan);
        }
    }

    if(!selectedPlan) return <p>Loading...</p>;
    return (
        <div className="sidebar">
            <div className="dropdown" onClick={() => setOpenPlans(true)}>
                {selectedPlan.name}
                <i className={`fa-solid ${openPlans ? "fa-chevron-up" : "fa-chevron-down"}`}></i>
                {openPlans ? <div id="modal" style={{width: "100%", right: 0}} className="modal">
                    <div>
                        {plans.map((plan, index) => (
                            <div onClick={() => handleSelect(plan.uid)} style={{padding: "10px"}} className={`lang-option ${index === 0 ? 'first' : 'not-first'}`} key={plan.uid}>
                                <p className="lang-text">{plan.name + ' '}</p>
                                {selectedPlan.uid === plan.uid ? <i className="fa-solid fa-check"></i> : null}
                            </div>
                        ))}
                        <div onClick={() => handleSelect("new")} style={{padding: "10px"}} className='lang-option not-first'>
                            <p className="lang-text">+ create new plan</p>
                        </div>
                        </div>
                    </div> : null}
            </div>
            <div style={{display: "flex", flexDirection: "column", justifyContent: "space-between", height: "85%"}}>
            <div style={{display: "flex", flexDirection: "column"}}>
            {routing.filter(route => route.admin != true).map((route, index) => (
                <NavLink className="navlink" key={index} to={`/${lang}/${route.path}`}>
                <div className={loc.pathname == `/${lang}/${route.path}` ? "navlink-container active" : "navlink-container"} style={{}} key={index}>
                <i className={route.icon}></i> {translate(route.name)}
                </div>
                </NavLink>

            ))}
            </div>
            <div style={{display: "flex", flexDirection: "column"}}>
            {routing.filter(route => route.admin == true).map((route, index) => (
                <NavLink className="navlink" key={index} to={`/${lang}/${route.path}`}>
                <div className={loc.pathname == `/${lang}/${route.path}` ? "navlink-container active" : "navlink-container"} style={{}} key={index}>
                <i className={route.icon}></i> {translate(route.name)}
                </div>
                </NavLink>

            ))}
            </div>
            </div>
        </div>
    )
}
export default SideBar;